export default "__VITE_ASSET__B305G5jh__"